import { styled } from 'solid-styled-components';

export const Styled404 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    margin: 5rem;
`;